import Layout from "./components/Layout";
import "./styles/output.css";
import React from "react";
import { Switch, Route, useHistory } from "react-router-dom";
import Home from "./pages/Home";
import PageCTA from "./pages/PageCTA";
import MyAccount from "./pages/MyAccount";
import SignIn from "./pages/SignIn";
import AddCard from "./components/Forms/AddCard";
import PayForm from "./components/Forms/Pay";
// import { STRIPE_PK } from "./constant";
// import { loadStripe } from "@stripe/stripe-js";
import RecapRDV from "./pages/RecapRDV";
import BookingRecap from "./pages/BookingRecap";
import Categories from "./pages/Categories";
import Prestataires from "./pages/Prestataires";
import PriseRDV from "./pages/PriseRDV";
import Legales from "./pages/Legales";
import MentionsLegales from "./pages/MentionsLegales";
import CGV from "./pages/Cgv";
import Privacy from "./pages/Privacy";
import Refund from "./pages/Refund";
import EditRDV from "./pages/EditRDV";
// import { Elements } from "@stripe/react-stripe-js";

// const stripePromise = loadStripe(STRIPE_PK);

function App() {
  const history = useHistory();

  React.useEffect(() => {
    history.listen((location, action) => {
      // location is an object like window.location
      // console.log("history.listen", action, location.pathname, location.state);
      //all change location to scroll top in window
      if (action === "PUSH" || action === "REPLACE" || action === "POP") {
        window.scrollTo(0, 0);
      }
    });
  }, []);

  return (
    <>
      <Layout>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/sign-in">
            <SignIn />
          </Route>
          <Route path="/mon-compte">
            <MyAccount />
          </Route>
          <Route path="/categories/:id">
            <Categories />
          </Route>
          <Route path="/p/:id">
            <Prestataires />
          </Route>
          <Route path="/privacy">
            <Privacy />
          </Route>
          <Route path="/refund">
            <Refund />
          </Route>
          <Route path="/pro">
            <PageCTA />
          </Route>
          <Route path="/add-method-card">
            <AddCard />
          </Route>
          <Route path="/editrdv/:id">
            <EditRDV />
          </Route>
          <Route path="/prise-de-rendez-vous/:id">
            <PriseRDV />
          </Route>
          <Route path="/recapitulatif">
            <RecapRDV />
          </Route>
          <Route path="/checkout/:id">
            <PayForm />
          </Route>
          <Route path="/booking-recap/:id">
            <BookingRecap />
          </Route>
          <Route path="/cgu">
            <Legales />
          </Route>
          <Route path="/cgv">
            <CGV />
          </Route>
          <Route path="/mentions-legales">
            <MentionsLegales />
          </Route>
        </Switch>
      </Layout>
    </>
  );
}

export default App;
